import http from './http';

import { createLogger } from '../utils/logger';

const logger = createLogger('music');
export interface MusicRec {
  id: string;
  userId?: string;
  preludeMusic?: string;
  processionalMusic?: string;
  hymnsSongs?: string;
  specialMusic?: string;
  recessionalMusic?: string;
  favoriteSongs?: string;
  liveMusicians?: string;
  recordedMusic?: boolean;
  avoidMusic?: string;
  culturalMusic?: string;
  specialRequests?: string;
  notes?: string;
  isLocked?: boolean;
  createdAt?: Date;
  updatedAt?: Date;
}

class MusicService {

  async getAllMusic(): Promise<MusicRec[]> {
    try {
      const response = await http.get('/api/music');
      return response.data;
    } catch (error) {
      logger.error('Error fetching music preferences:', error);
      throw error;
    }
  }

  async getMusicById(id: string): Promise<MusicRec> {
    try {
      const response = await http.get(`/api/music/${id}`);
      return response.data;
    } catch (error) {
      logger.error('Error fetching music by ID:', error);
      throw error;
    }
  }

  async createMusic(data: Partial<MusicRec>): Promise<MusicRec> {
    try {
      const response = await http.post('/api/music', data);
      return response.data;
    } catch (error) {
      logger.error('Error creating music preferences:', error);
      throw error;
    }
  }

  async updateMusic(id: string, data: Partial<MusicRec>): Promise<MusicRec> {
    try {
      const response = await http.put(`/api/music/${id}`, data);
      return response.data;
    } catch (error) {
      logger.error('Error updating music preferences:', error);
      throw error;
    }
  }

  async deleteMusic(id: string): Promise<void> {
    try {
      await http.delete(`/api/music/${id}`);
    } catch (error) {
      logger.error('Error deleting music preferences:', error);
      throw error;
    }
  }

  async lockMusic(id: string): Promise<void> {
    logger.debug('[Service Debug] Calling lock API for music ID:', id);
    try {
      const response = await http.post(`/api/music/${id}/lock`);
      logger.debug('[Service Debug] Lock API response:', response.data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Failed to lock music preferences');
      }
    } catch (error) {
      logger.error('Error locking music preferences:', error);
      throw error;
    }
  }

  async unlockMusic(id: string, selectedEmails: string[] = []): Promise<void> {
    logger.debug('[Service Debug] Calling unlock API for music ID:', id);
    logger.debug('[Service Debug] Selected emails:', selectedEmails);
    try {
      const response = await http.post(`/api/music/${id}/unlock`, {
        selectedEmails: selectedEmails
      });
      logger.debug('[Service Debug] Unlock API response:', response.data);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Failed to unlock music preferences');
      }
    } catch (error) {
      logger.error('Error unlocking music preferences:', error);
      throw error;
    }
  }

  async getMusicAccessGrants(id: string): Promise<any[]> {
    try {
      const response = await http.get(`/api/music/${id}/access-grants`);
      return response.data;
    } catch (error) {
      logger.error('Error fetching music access grants:', error);
      return [];
    }
  }
}

export const musicService = new MusicService();